type FirstFunction = {
    <T>(array: T[]): T | undefined;
    (array: string): string | undefined;
};

export const first: FirstFunction = <T>(array: T[] | string): T | string | undefined => array?.[0];
